import styled, { css } from 'styled-components';
import { Breakpoints, FontWeight } from '../../../../styled/constants';
import { globalSystemColors } from '../../../../styled/theme/constants';

export const InfoBlockWrapper = styled.aside`
  background: #19191b;
  border-bottom-right-radius: 16px;
  border-top-right-radius: 16px;
  padding: 50px 30px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media (min-width: ${Breakpoints.desktop}px) {
    flex: 1 1 48%;
  }
  @media (max-width: ${Breakpoints.desktop}px) {
    border-top-right-radius: 0;
    border-bottom-left-radius: 16px;
    padding: 30px;
  }
  @media (max-width: ${Breakpoints.tablet}px) {
    min-width: 0;
    width: 100%;
    padding: 20px;
  }
`;

export const InfoBlockInner = styled.div`
  background: #19191b;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 24px;
  font-weight: ${FontWeight.bold};
  margin-bottom: 20px;
  @media (max-width: ${Breakpoints.tablet}px) {
    font-size: 20px;
    margin-bottom: 15px;
  }
`;

export const Subtitle = styled.div`
  font-size: 16px;
  color: rgba(254, 254, 254, 0.6);
  margin-bottom: 30px;
  @media (max-width: ${Breakpoints.tablet}px) {
    font-size: 14px;
  }
`;

export const FeaturesList = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 30px;
  list-style: none;
  padding: 0;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 14px;
`;

export const FeatureIcon = styled.div<{ $type?: string; $iconUrl?: string }>`
  width: 16px;
  height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
  ${({ $type, $iconUrl }) => {
    if ($type === 'deadline') {
      return css`
        background-image: url('/static/images/pasha/calendar.svg');
      `;
    }
    if ($type === 'buildingClass') {
      return css`
        background-image: url('/static/images/pasha/icon.svg');
      `;
    }
    if ($iconUrl) {
      return css`
        background-image: url(${$iconUrl});
      `;
    }
    return '';
  }}
`;

export const MoreButton = styled.a`
  display: inline-block;
  margin-top: auto;
  background: ${({ theme }) => theme.colors.text.primary};
  color: ${globalSystemColors.cocoaBrown};
  border-radius: 14px;
  padding: 16px 0;
  text-align: center;
  font-size: 16px;
  font-weight: ${FontWeight.thin};
  text-decoration: none;
  width: 100%;
  &:hover {
    background: ${globalSystemColors.blue};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    margin-top: 0;
  }
`;
